export default __webpack_public_path__ + "static/media/file.decf72b4.svg";